import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { Feature } from 'src/replicant/analytics';
import sounds from 'src/lib/sounds';
import StateObserver from 'src/StateObserver';
import { assertNever } from 'src/replicant/utils';
import { GachaEventTheme } from 'src/replicant/gacha/gacha.ruleset';
import { openGachaSelectionPopup } from '../gacha/gacha.sequence';
import { isDecorationGachaEventAvailable } from './helpers';
import { gachaTheme } from '../gacha/gacha.theme';

/**
 * Allow users to buy event specific gacha
 * See: src/game/components/ShopMenu.ts
 */
export class GachaShopBanner extends FlexBoxView {
  private button: ButtonScaleView;
  private theme: GachaEventTheme;

  /**
   * @property opts.onSelect - After popup close callback
   */
  constructor(opts: { onSelect: () => void; theme: GachaEventTheme }) {
    super({
      width: 542,
      height: 170,
    });

    this.theme = opts.theme;

    this.button = new ButtonScaleView({
      superview: this,
      ...this.getButtonView(),
      pressedOffsetY: 5,
      tracking: {
        feature: Feature.GACHA._,
        $subFeature: Feature.GACHA.EVENT_GACHA_SHOP_BUTTON,
      },
      onClick: async () => {
        if (!isDecorationGachaEventAvailable()) {
          this.updateOpts({
            visible: false,
          });
          return;
        }

        sounds.sfx.play('ok');
        await openGachaSelectionPopup();
        opts.onSelect();
      },
    });
  }

  /**
   * Return button view
   */
  private getButtonView() {
    return this.getThemedGachaImage();
  }

  private getThemedGachaImage() {
    const locale = StateObserver.getLocale();
    return {
      width: 542,
      height: 170,
      ...gachaTheme().getStyle(`shop_banner_${locale}`),
    };
  }
}
